import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2cd1d8ee"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cd1d8ee')) {
      api.createRecord('2cd1d8ee', component.options)
    } else {
      api.reload('2cd1d8ee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2cd1d8ee", function () {
      api.rerender('2cd1d8ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/design/activityDesign/index.vue"
export default component.exports